import { CheckCircle, Clock, Send, AlertTriangle, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const statusConfig: Record<string, { label: string; icon: typeof CheckCircle; iconColor: string }> = {
  draft: { label: 'Draft', icon: Clock, iconColor: 'text-muted-foreground' },
  sent: { label: 'Sent', icon: Send, iconColor: 'text-blue-600' },
  paid: { label: 'Paid', icon: CheckCircle, iconColor: 'text-green-600' },
  overdue: { label: 'Overdue', icon: AlertTriangle, iconColor: 'text-red-600' },
  cancelled: { label: 'Cancelled', icon: XCircle, iconColor: 'text-muted-foreground' },
};

interface InvoiceFiltersProps {
  statusFilter: string | undefined;
  onStatusFilterChange: (status: string | undefined) => void;
}

export function InvoiceFilters({ statusFilter, onStatusFilterChange }: InvoiceFiltersProps) {
  return (
    <div className="flex gap-2 flex-wrap">
      <Button
        variant={statusFilter === undefined ? 'default' : 'outline'}
        size="sm"
        onClick={() => onStatusFilterChange(undefined)}
      >
        All
      </Button>
      {Object.entries(statusConfig).map(([key, config]) => (
        <Button
          key={key}
          variant={statusFilter === key ? 'default' : 'outline'}
          size="sm"
          onClick={() => onStatusFilterChange(key)}
        >
          <config.icon className={cn('w-4 h-4 mr-1', statusFilter !== key && config.iconColor)} />
          {config.label}
        </Button>
      ))}
    </div>
  );
}
